import React from 'react';
import { styled } from '@linaria/react';
import { Divider } from '@daedalus/atlas/Divider';
import { SearchOffer } from '@daedalus/core/src/offer/types/SearchOffer';
import { AlternativeOfferInteraction } from './AlternativeOfferInteraction';
import { Primary, Secondary } from './Offer';
const ListWrapper = /*#__PURE__*/styled('div')({
  name: "ListWrapper",
  class: "l1b3r5ui",
  propsAsIs: false
});
type OffersListProps = {
  offers: SearchOffer[];
};
export const AlternativeOffersList = ({
  offers
}: OffersListProps) => {
  return <ListWrapper>
      {offers.map((offer, index) => <React.Fragment key={offer.id}>
          <AlternativeOfferInteraction offer={offer}>
            {index === 0 ? <Primary offer={offer} /> : <Secondary offer={offer} />}
          </AlternativeOfferInteraction>
          {index > 0 && offers.length > 2 && index !== offers.length - 1 ? <Divider sideMargin="s400" /> : null}
        </React.Fragment>)}
    </ListWrapper>;
};

require("./AlternativeOffersList.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./AlternativeOffersList.tsx");